import React, { Component } from 'react';
import {  Row, Col } from 'reactstrap';
import { Link } from 'react-router';
import { TextInputField,DateInputField, GetInputField } from '../../../Elements';
import { imgStoragePath, displayDateFormat } from '../../../../../constants';

export default class DisassemblyFinding extends Component {
  constructor(props) {
    super(props);
  }


  updateForm = () => {

  }
  render() {
  const { disAssemblyFnding, index } = this.props;
  let type = 'edit';
  return(
    <tr>
			<td>{index+1}</td>
			<td>{disAssemblyFnding.title}</td>
			<td dangerouslySetInnerHTML={{__html: disAssemblyFnding.remarks}} ></td>
			<td>
      {/*<img width="12"  style={{ display: 'inline-block', marginRight: '8px'}}
          onClick = {() => this.props.editViewDisAssemBlk(disAssemblyFnding.id,'edit')}
        className="edit-img-blk" src={imgStoragePath+"blue_eye_icon.png"}
        /> */}
        <img width="12"  style={{ display: 'inline-block', marginRight: '8px'}}
          onClick = {() => this.props.editViewDisAssemBlk(disAssemblyFnding.id,'edit')}
        className="edit-img-blk" src={imgStoragePath+"icon_editblock.png"}
        />
       <img width="12" onClick = {() => this.props.toggleDelModal(disAssemblyFnding.id, 'dissasembly', index)} className="" src={imgStoragePath+"delete_red.png"}/>
      </td>

      </tr>
    );
  }
}
